import { FormGroup } from '@angular/forms';

export class InputField {
  id?: number;
  label?: string;
  class?: string;
  containerClass?: string;
  type?: string;
  value?: any;
  placeholder?: string;
  formControlName?: string;
  formGroup?: FormGroup;
  formGroupName?: any;
  errorMessage?: string;
  dropdownOptions?: any;
  optionValue?: string;
  optionLabel?: string;
  price?: string;
  fieldFormGroup?: string;
  fullRow?: boolean;
  validators?: any;
  filter?: boolean;
}
